export const mapGlobalVariablesToCADInteractionControl = (data) => {
    if (!data || !Array.isArray(data)) {
        return {};
    }
    return data.reduce((acc, item) => {
        if (item && item.key) {
            acc[item.key] = {
                displayName: item.key,
                name: item.key,
                value: item.val || "",
                type: "STRING",
                agentEditable: false,
                agentViewable: true,
                isSecure: false,
                secureKeyId: "",
                secureKeyVersion: 0
            };
        }
        return acc;
    }, {});
};
